import { ReactNode, useState, useEffect } from "react";
import AppHeader from "../components/AppHeader";
import AppContainer from "../components/AppContainer";
import AppSidebar from "../components/AppSidebar";
import WhereDidUHearPopup from "../components/WhereDidUHearPopup";
import { useUser } from "../contexts/UserContext";
import Onboarding from "../components/Onboarding";
import IntercomWrapper from "../provider/IntercomProvider";

import "./AppLayout.css";
import IntercomIdentity from "../provider/IntercomIdentity";

export default function AppLayout({ children }: { children: ReactNode }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { isLoading, should_ask_for_referrer_source } = useUser();
  const [showPopup, setShowPopup] = useState(false);
  const [showToast, setShowToast] = useState<string | null>(null);
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    if (!isLoading && should_ask_for_referrer_source) {
      setShowPopup(true);
    } else if (!isLoading && !should_ask_for_referrer_source) {
      setShowPopup(false);
    }
  }, [isLoading, should_ask_for_referrer_source]);

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handleClosePopup = (shouldShowToast?: boolean) => {
    setShowPopup(false);

    if (shouldShowToast !== undefined) {
      const message = shouldShowToast
        ? "Thanks for sharing! We appreciate your feedback."
        : "";

      setTimeout(() => {
        setShowToast(message);
        setTimeout(() => setShowToast(null), 5000);
      }, 100);
    }

    const delay = shouldShowToast === false ? 2000 : 4000;
    setTimeout(() => setShowOnboarding(true), delay);
  };

  return (
    <IntercomWrapper>
      <IntercomIdentity />
      <div className="app-layout">
        <AppHeader onToggleSidebar={handleToggleSidebar} />
        <AppContainer>
          <div className="app-layout-content">
            <div className="app-layout-sidebar">
              <AppSidebar isSidebarOpen={isSidebarOpen} />
            </div>
            <div className="app-layout-main">{children}</div>
          </div>

          {showPopup && <WhereDidUHearPopup onClose={handleClosePopup} />}

          {showToast && <div className="popup-toast">{showToast}</div>}

          {showOnboarding && <Onboarding />}
        </AppContainer>
      </div>
    </IntercomWrapper>
  );
}
